import { render } from "./date-input.vue?vue&type=template&id=5b8e2aaa&scoped=true"
import script from "./date-input.vue?vue&type=script&lang=js"
export * from "./date-input.vue?vue&type=script&lang=js"

import "./date-input.vue?vue&type=style&index=0&id=5b8e2aaa&scoped=true&lang=css"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8e2aaa"]])

export default __exports__